const styles = [{
    'section': {
        'available': {
            'normal': {
                'none': {
                    'strokeStyle': '#198042',
                    'fill-opacity': 0.7,
                    'stroke-opacity': 1,
                    'lineWidth': 1,
                    'cursor': 'auto',
                    'transition': 'fill 0.5s, fill-opacity 0.5s',
                    'opacity': 0,
                    'fillStyle': '#a7a6a6',
                    'strokeOpacity': 0,
                },
            },
            'hover': {
                'none': {
                    'fill-opacity': 0.7,
                    'stroke-opacity': 1,
                    'lineWidth': 1,
                    'cursor': 'pointer',
                    'fillStyle': '',
                    'opacity': 0.9,
                    'strokeStyle': 0,
                },
            },
        },
        'selected': {
            'normal': {
                'none': {
                    'fillStyle': '#FF4D4D',
                    'strokeStyle': '#801A1A',
                    'fill-opacity': 0.7,
                    'stroke-opacity': 1,
                    'lineWidth': 1,
                    'cursor': 'auto',
                    'opacity': 1,
                },
            },
            'hover': {
                'none': {
                    'fillStyle': '#FFCCCC',
                    'strokeStyle': '#FF4D4D',
                    'fill-opacity': 0.7,
                    'stroke-opacity': 1,
                    'lineWidth': 1,
                    'cursor': 'pointer',
                    'opacity': 1,
                    'transition': 'fill 0.5s, fill-opacity 0.5s',
                },
            },
        },
        'unavailable': {
            'normal': {
                'none': {
                    'cursor': 'not-allowed',
                    'fillStyle': '#bebebe',
                    'opacity': 0.56,
                },
            },
        },
        'disabled': {
            'normal': {
                'none': {
                    'fillStyle': '#fff',
                    'cursor': 'auto',
                    'opacity': 0,
                },
            },
        },
    },
    'seat': {
        'available': {
            'normal': {
                'none': {
                    'strokeStyle': '#198042',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'fillStyle': '#40a27b',
                },
                'restricted': {
                    'fillStyle': '#36B369',
                    'strokeStyle': '#198042',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-restricted',
                },
                'visibility-reduced': {
                    'fillStyle': '#36B369',
                    'strokeStyle': '#198042',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-restricted',
                },
                'pending': {
                    'fillStyle': '#36B369',
                    'strokeStyle': '#198042',
                    'lineWidth': 0.05,
                    'cursor': 'not-allowed',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'transition': 'fill 0.5s, fill-opacity 0.5s',
                },
                'disabled': {
                    'fillStyle': '#36B369',
                    'strokeStyle': '#198042',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-disabled',
                },
                'disabled2': {
                    'fillStyle': '#36B369',
                    'strokeStyle': '#198042',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-disabled-2',
                },
                'social-distancing': {
                    'fillStyle': '#fff',
                    'strokeStyle': '#fff',
                    'lineWidth': 0.1,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-social-distancing',
                },
            },
            'hover': {
                'none': {
                    'fillStyle': '#CCFFE1',
                    'strokeStyle': '#36B369',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                },
                'visibility-reduced': {
                    'fillStyle': '#CCFFE1',
                    'strokeStyle': '#36B369',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-restricted',
                },
                'restricted': {
                    'fillStyle': '#CCFFE1',
                    'strokeStyle': '#36B369',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-restricted',
                },
                'pending': {
                    'fillStyle': '#CCFFE1',
                    'strokeStyle': '#36B369',
                    'lineWidth': 0.05,
                    'cursor': 'not-allowed',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'transition': 'fill 0.5s, fill-opacity 0.5s',
                },
                'disabled': {
                    'fillStyle': '#CCFFE1',
                    'strokeStyle': '#36B369',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-disabled',
                },
                'disabled2': {
                    'fillStyle': '#CCFFE1',
                    'strokeStyle': '#36B369',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-disabled-2',
                },
                'social-distancing': {
                    'fillStyle': '#fff',
                    'strokeStyle': '#fff',
                    'lineWidth': 0.1,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-social-distancing',
                },
            },
        },
        'selected': {
            'normal': {
                'none': {
                    'fillStyle': '#FF4D4D',
                    'strokeStyle': '#801A1A',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-check',
                },
                'restricted': {
                    'fillStyle': '#FF4D4D',
                    'strokeStyle': '#801A1A',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-restricted',
                },
                'visibility-reduced': {
                    'fillStyle': '#FF4D4D',
                    'strokeStyle': '#801A1A',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-restricted',
                },
                'disabled': {
                    'fillStyle': '#FF4D4D',
                    'strokeStyle': '#801A1A',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-disabled',
                },
                'disabled2': {
                    'fillStyle': '#FF4D4D',
                    'strokeStyle': '#801A1A',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-disabled-2',
                },
                'social-distancing': {
                    'fillStyle': '#fff',
                    'strokeStyle': '#fff',
                    'lineWidth': 0.1,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-social-distancing',
                },
            },
            'hover': {
                'none': {
                    'fillStyle': '#FFCCCC',
                    'strokeStyle': '#FF4D4D',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-check',
                },
                'restricted': {
                    'fillStyle': '#FFCCCC',
                    'strokeStyle': '#FF4D4D',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-restricted',
                },
                'visibility-reduced': {
                    'fillStyle': '#FFCCCC',
                    'strokeStyle': '#FF4D4D',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-restricted',
                },
                'disabled': {
                    'fillStyle': '#FFCCCC',
                    'strokeStyle': '#FF4D4D',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-disabled',
                },
                'disabled2': {
                    'fillStyle': '#FFCCCC',
                    'strokeStyle': '#FF4D4D',
                    'lineWidth': 0.05,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-disabled-2',
                },
                'social-distancing': {
                    'fillStyle': '#fff',
                    'strokeStyle': '#fff',
                    'lineWidth': 0.1,
                    'cursor': 'pointer',
                    'fillOpacity': 0.7,
                    'opacity': 1,
                    'icon': 'icon-social-distancing',
                },
            },
        },
        'unavailable': {
            'normal': {
                'social-distancing': {
                    'fillStyle': '#fff',
                    'fillOpacity': 0,
                    'opacity': 1,
                    'cursor': 'not-allowed',
                },
            },
        },
    },
}];

export class SeatMap {
    constructor(venueId) {
        this.venueId = venueId;
        this.styles = styles;
        this.store = Alpine.store('seatMap');
        this.wire = window.Livewire;

        if (this.store.is3d()) {
            const viewerPromise = DVM.loadModule('map_viewer', {
                container: 'viewer-container',
                callbacks: {
                    click: this.onClick.bind(this),
                    leave: () => {
                        setTimeout(() => {
                            this.store.resetPreview();
                        }, 200);
                    },
                    enter: (e) => {
                        setTimeout(() => {
                            if (window.innerWidth >= 1024) {
                                const node = e.nodes[0];

                                if (node.type === 'section' && node.layer !== 'mainlayer') {
                                    return;
                                }

                                if (node && node.state === 'available') {
                                    const containerRect = e.original_event.target.closest('.o-seatMap').getBoundingClientRect();
                                    const containerHeight = e.original_event.target.closest('.o-seatMap').clientHeight;
                                    const containerWidth = e.original_event.target.closest('.o-seatMap').clientWidth;
                                    const previewDivWidth = 250;
                                    const previewDivHeight = 200;
                                    const padding = containerWidth < 600 ? 10 : 30;

                                    const mouseX = e.original_event.clientX - containerRect.left;
                                    const mouseY = e.original_event.clientY - containerRect.top;
                                    let currentX = mouseX + padding;
                                    let currentY = mouseY;
                                    const rightEdge = currentX + previewDivWidth;
                                    const bottomEdge = currentY + previewDivHeight;
                                    const topEdge = currentY - previewDivHeight;

                                    if (rightEdge > containerWidth) {
                                        currentX = mouseX - previewDivWidth - padding;
                                    }

                                    if (bottomEdge > containerHeight) {
                                        currentY = mouseY - previewDivHeight - padding;
                                    } else if (currentY < padding) {
                                        currentY = padding;
                                    }

                                    if (topEdge < 0) {
                                        currentY = mouseY + padding;
                                    }

                                    if (currentX < padding) {
                                        currentX = padding;
                                    }

                                    if (node.type === 'section' || node.type === 'seat') {
                                        this.store.preview = {
                                            ...this.store.preview,
                                            show: true,
                                            positionX: currentX,
                                            positionY: currentY,
                                        }
                                        node.instance
                                            .getThumbnail(node.id, undefined, true)
                                            .then((url) => {
                                                this.store.preview.imgUrl = url;
                                            });
                                    }
                                    if (node.type === 'section') {
                                        const section = this.store.sections().find((section) => section.mmc_identifier === node.id);
                                        const priceFrom = this.store.priceRangeBySection[section.id].lower_price;
                                        const stand = section.ancestors.find((ancestor) => ancestor.section_type === 'Stand');
                                        this.store.preview = {
                                            ...this.store.preview,
                                            standName: stand.identifier,
                                            blockName: section.identifier,
                                            priceFrom: `£${priceFrom / 100}`,
                                            rowName: null,
                                            seatName: null,
                                        };
                                    }
                                    if (node.type === 'seat') {
                                        const idParts = node.id.substring(2).split('-');
                                        this.store.preview = {
                                            ...this.store.preview,
                                            standName: null,
                                            priceFrom: null,
                                            blockName: idParts[0],
                                            rowName: idParts[1],
                                            seatName: idParts[2],
                                        };
                                    }
                                }
                            }
                        }, 200);
                    },
                },
            });

            this.store.showLoading();

            Promise.all([viewerPromise])
                .then((result) => {
                    this.viewer = result[0];
                    this.start().then(() => {
                        this.store.hideLoading();
                    });
                })
                .catch((err) => {
                    console.error(err);
                })
            ;

            window.addEventListener('update-selected-and-available', (e) => {
                setTimeout(() => {
                    if (e.detail.section !== 'blockmap') {
                        const available = e.detail.available?.map((s) => s.mmc_identifier);
                        const selSeats = e.detail.selected?.map((s) => s.mmc_identifier);

                        this.viewer.setAvailability('seat', available, e.detail.section);
                        this.viewer.unselect(available);
                        this.viewer.setAvailable('seat', selSeats, e.detail.section);
                        this.viewer.select(selSeats);

                    } else {
                        this.viewer.setAvailability('section', e.detail.available_sections);
                        this.store.hideBackButton();
                    }

                    this.store.hideLoading();
                });
            });

            window.addEventListener('back-to-blockmap', () => {
                this.store.showLoading();
                this.store.resetPreview();
                this.start().then(async () => {
                    await this.store.resetSection();
                    this.store.hideBackButton();
                    this.store.hideLoading();
                });
            })
        }
    }

    async start(id = 'blockmap') {
        if (id === 'blockmap') {
            this.store.selectedSectionDisplayName = null;
        }

        await this.viewer
            .loadMap({
                venue_id: this.venueId, // Venue to be loaded. 3ddigitalvenue will provide these IDs
                map_id: id,
            })
            .then(() => {
                this.viewer.flags.automatic_selection = false;
                this.viewer.setAvailability('section', this.store.availableSections());
                this.viewer.setStyles(this.styles);
            })
            .catch((err) => {
                console.error(err);
            })
        ;
    }

    onClick(obj) {
        const node = obj.nodes[0];

        if (!node) {
            return;
        }

        this.store.resetPreview();

        const section = this.store.sections()
            .find((s) => s.mmc_identifier === node.id || s.mmc_identifier === node.parent)
        ;

        if (node.type === 'section' && node.state === 'available' && this.viewer.getMapId() === 'blockmap') {
            this.store.showLoading();
            this.store.showBackButton();
            this.start(node.id).then(() => {
                this.store.changeMap(section.id);
                const topParent = section.ancestors.find((ancestor) => ancestor.seat_section_id === null);
                this.store.selectedSectionDisplayName = `${topParent ? topParent.identifier + " / " : ""} ${section.identifier}`;
            });
        }

        if (node.type !== 'seat') {
            return;
        }

        const protectClick = (node) => {
            if (node.state === 'available' || node.state === 'selected') {
                window.dispatchEvent(
                    new CustomEvent('basket-start-loading')
                );
            }

            if (node.state === 'available') {
                const seat = this.store.availableSeats().find((s) => s.mmc_identifier === node.id);
                this.wire.emitTo('basket', 'addToBasket', seat.basketable_type, seat.basketable_id);
                this.viewer.select(node);
                return;
            }

            if (node.state === 'selected') {
                const seat = this.store.selectedSeats().find((s) => s.mmc_identifier === node.id);
                this.wire.emitTo('basket', 'removeFromBasket', seat.item_id, seat.basketable_type);
                this.viewer.unselect(node);
            }
        }
        authProtectedClick(null, {click: protectClick}, 'click', [node]);
    }
}

export default SeatMap;
